module.exports = __webpack_public_path__ + "MindLeadsBodyPurple.png?9613eb54d95a305b4ce9d635b98c9f40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marathondynamics/MindLeadsBodyPurple.png
// module id = 192
// module chunks = 0